import { type VariantProps, cva } from "class-variance-authority";

export type MessageVariants = VariantProps<typeof messageVariants>;
export const messageVariants = cva(
  "flex rounded-xl gap-3 px-4 py-3 relative font-medium",
  {
    variants: {
      type: {
        success: "bg-success text-success",
        error: "bg-error text-error",
        info: "bg-info text-info",
        warning: "bg-warning text-warning",
        neutral: "bg-secondary text-secondary",
      },
    },
  },
);
